import { leviathanRules } from "@personnel/rules-leviathan";
import { CaptainBuilder } from "../features/captains/CaptainBuilder.js";

export function Captains() {
  return (
    <div className="flex flex-col gap-8">
      <div className="max-w-2xl">
        <span className="font-display text-xs font-semibold tracking-[0.18em] text-leviathan-500 uppercase">
          Leviathan
        </span>
        <h1 className="mt-2 font-display text-3xl font-semibold text-white">Captains</h1>
        <p className="mt-3 text-sm leading-relaxed text-void-400">
          Ruleset <code className="text-leviathan-500">{leviathanRules.version}</code>. Advancement
          is not implemented yet — those rules are still being written.
        </p>
      </div>

      <CaptainBuilder />
    </div>
  );
}
